module.exports = __webpack_public_path__ + "static/media/trial3.5825b6b7.mp3";